import Alert from '@mui/material/Alert';

export default function StepQuotation() {
  return <Alert severity='info'>Project Quotation Details coming soon!</Alert>;
}
